module.exports = __webpack_public_path__ + "static/img/17.70a4c07.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/6/sp/17.png
// module id = 1k5m
// module chunks = 0